import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { AuthInterceptor } from '@libs/core/auth';
import { CarrierInterceptor } from '@libs/core/auth-pt';
import { ApiErrorsInterceptor, NOTIFICATION_SERVICE } from './api-error.interceptor';
import { AlertService } from './alert.service';

export const httpInterceptorsProviders: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, multi: true, useClass: CarrierInterceptor },
  { provide: HTTP_INTERCEPTORS, multi: true, useClass: ApiErrorsInterceptor },
  { provide: NOTIFICATION_SERVICE, useClass: AlertService },
];
